import { render, staticRenderFns } from "./userPerformanceIndex.vue?vue&type=template&id=aca3167e&"
import script from "./userPerformanceIndex.vue?vue&type=script&lang=js&"
export * from "./userPerformanceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports